var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJiraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 71.81 71.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2684ff;}.cls-2{fill:url(#New_Gradient_Swatch_1);}.cls-3{fill:url(#New_Gradient_Swatch_1-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 53.96,
    y1: 17.29,
    x2: 39.25,
    y2: 32.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    x1: 37.83,
    y1: 34.62,
    x2: 20.82,
    y2: 51.16,
    xlinkHref: "#New_Gradient_Swatch_1"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Jira-icon-blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.81,0H34.23A15.61,15.61,0,0,0,49.84,15.61h6.37v6.15A15.61,15.61,0,0,0,71.81,37.36V3A3,3,0,0,0,68.81,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.7,17.23H17.12A15.61,15.61,0,0,0,32.72,32.83h6.37V39A15.61,15.61,0,0,0,54.7,54.59V20.23A3,3,0,0,0,51.7,17.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.58,34.45H0A15.61,15.61,0,0,0,15.61,50.06H22v6.15A15.61,15.61,0,0,0,37.58,71.81V37.45A3,3,0,0,0,34.58,34.45Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraIcon);
export default __webpack_public_path__ + "static/media/jira_icon.94adbaad13e181a93e2c1f9e7bf32796.svg";
export { ForwardRef as ReactComponent };